import React, { useState, useEffect } from 'react';
import vr from '../../../../../utils/Verifiers';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import './formularioRegistroBloque.css';
import FormulasBloques from './FormulasBloques';

const FormularioRegistroBloque = (p) => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const formulas = new FormulasBloques();
    const selecciones = p.selecciones ?? {};
    const setselecciones = p.setselecciones ?? (() => { });
    const [dialog, setdialog] = useState({ show: false });
    const [bloques, setbloques] = useState([]);
    const [flores, setflores] = useState([]);
    const [variedades, setvariedades] = useState([]);
    const [colores, setcolores] = useState([]);
    const getFlores = async () => {
        setbloques(p.flores ?? []);
        setflores(Object.keys(p.flores ?? {}));
        setvariedades([]);
        setcolores([]);
    }

    const changeBloque = (ev) => {
        const { name, value } = ev.target;

        if (name === 'flor') {
            const florData = bloques[value] || {};
            setvariedades(Object.keys(florData.variedades || {}));
            setcolores([]);
            setselecciones((prev) => ({ ...prev, flor: value, variedad: '', color: '' }));
            return;
        }

        if (name === 'variedad') {
            const florData = bloques[selecciones.flor] || {};
            const variedadData = florData.variedades?.[value] || {};
            setcolores(Object.keys(variedadData.colores || {}));
            setselecciones((prev) => ({ ...prev, variedad: value, color: '' }));
            return;
        }

        setselecciones((prev) => ({ ...prev, color: value }));
    }

    const changeFechas = (ev) => {
        const { name, value } = ev.target;
        const numericValue = Number(value);

        setselecciones((prev) => {
            let semanaSiembra = Number(prev.semanasiembra) || 0;
            let cicloPropagacion = Number(prev.ciclopropagacion) || 0;
            let semanaTrasplante = Number(prev.semanatrasplante) || 0;
            let cicloCampo = Number(prev.ciclocampo) || 0;
            let semcampo = Number(prev.semcampo) || 0;
            const nextState = { ...prev };

            if (name === 'semanasiembra') {
                if (!formulas.semanaValida(value)) {
                    nextState[name] = numericValue;
                    return nextState;
                }
                semanaSiembra = numericValue;
                semanaTrasplante = formulas.sumar_semanas(+semanaSiembra, cicloPropagacion, setdialog);
                if (!semanaTrasplante) {
                    nextState[name] = numericValue;
                    return nextState;
                }
                semcampo = formulas.sumar_semanas(+semanaTrasplante, cicloCampo, setdialog);
                if (!semcampo) {
                    nextState[name] = numericValue;
                    return nextState;
                }
            } else if (name === 'ciclopropagacion') {
                cicloPropagacion = numericValue;
                semanaTrasplante = formulas.sumar_semanas(+semanaSiembra, cicloPropagacion, setdialog);
                if (!semanaTrasplante) {
                    nextState[name] = numericValue;
                    return nextState;
                }
                semcampo = formulas.sumar_semanas(+semanaTrasplante, cicloCampo, setdialog);
                if (!semcampo) {
                    nextState[name] = numericValue;
                    return nextState;
                }
            } else if (name === 'ciclocampo') {
                cicloCampo = numericValue;
                semcampo = formulas.sumar_semanas(+semanaTrasplante, cicloCampo, setdialog);
                if (!semcampo) {
                    nextState[name] = numericValue;
                    return nextState;
                }
            }

            return {
                ...nextState,
                [name]: numericValue,
                semanatrasplante: semanaTrasplante,
                semcampo: semcampo,
                ciclocampo: cicloCampo,
                ciclopropagacion: cicloPropagacion,
            };
        });
    }

    function changeGerminado(ev) {
        const { name, value } = ev.target;

        setselecciones(prev => {
            let next = { ...prev, [name]: value };

            switch (name) {
                case 'plantas':
                    next = formulas.plantas(next);
                    break;
                case 'germinacion':
                    next = formulas.germinacion(next);
                    break;
                case 'sem.necesaria':
                    next = formulas.semillasnecesarias(next);
                    break;
                case 'cavidaddecharola':
                    next = formulas.cavidaddecharola(next);
                    break;
                case '#charolas':
                    next = formulas.charolas(next);
                    break;
                case 'densidad':
                    next = formulas.densidad(next);
                    break;
                case 'metrosnecesarios':
                    next = formulas.metrosnecesarios(next);
                    break;
                case 'recuperacion':
                    next = formulas.recuperacion(next);
                    break;
                case 'talloscosecha':
                    next = formulas.talloscosecha(next);
                    break;
                default:
                    break;
            }
            return next;
        });
    }

    function changeCampo(ev) {
        const { name, value } = ev.target;
    }

    const [gruposInputs, setgruposInputs] = useState([
        {
            name: "Fechas",
            funcion: changeFechas,
            inputs: [
                { name: "semanasiembra", tipo: "number", title: 'Sem. siembra', value: 0, editable: true },
                { name: "ciclopropagacion", tipo: "number", title: 'Ciclo propagación', value: 0, editable: true },
                { name: "ciclocampo", tipo: "number", title: 'Ciclo campo', value: 0, editable: true },
                { name: "semanatrasplante", tipo: "number", title: 'Sem. trasplante', value: 0, editable: false },
                { name: "semcampo", tipo: "number", title: 'Semana corte', value: 0, editable: false },
            ]
        },
        {
            name: "Germinado",
            funcion: changeGerminado,
            inputs: [
                { name: "plantas", tipo: "number", size: 120, title: '# Plantas', value: 0, editable: true },
                { name: "germinacion", tipo: "number", size: 120, title: 'Germinación', value: 0, editable: true },
                { name: "sem.necesaria", tipo: "number", size: 150, title: 'Semillas necesarias', value: 0, editable: true },
                { name: "cavidaddecharola", tipo: "number", size: 130, title: 'Cavidad charola', value: 0, editable: true },
                { name: "#charolas", tipo: "number", size: 130, title: '#charolas', value: 0, editable: true },
            ]
        },
        {
            name: "Campo",
            funcion: changeGerminado,
            inputs: [
                { name: "densidad", tipo: "number", size: 120, title: 'Densidad', value: 0, editable: true },
                { name: "metrosnecesarios", tipo: "number", size: 130, title: 'Metros nec.', value: 0, editable: true },
                { name: "camas", tipo: "number", size: 100, title: 'Camas', value: 1, editable: true },
                { name: "recuperacion", tipo: "number", size: 130, title: 'Recuperación', value: 0, editable: true },
                { name: "talloscosecha", tipo: "number", size: 130, title: 'Tallos cosecha', value: 0, editable: true },
            ]
        }
    ]);

    const relaciones = {
        'plantas': { toma: ["germinacion"], ajusta: ["sem.necesaria"] }
    }

    useEffect(() => {
        getFlores();
    }, [p.flores]);

    return (
        <>
            <div className='col-lg-12 m-0 p-2' style={{ lineHeight: 1.1 }}>
                <div className='row justify-content-center align-items-center w-100 m-0 p-0'>
                    <div className='' style={{ width: "100%", maxWidth: "1000px" }}>
                        <div className='row justify-content-start w-100'>
                            <div className='col-lg-12 text-start h4 fw-300 pb-0 mb-1'>Definición del bloque</div>
                            <div className='grid-inputs col-lg-12 m-0'>
                                <div className='form-group pb-2'>
                                    <label className='text-bold'>Flor</label>
                                    <select className='form-control' name='flor' value={selecciones.flor} onChange={changeBloque}>
                                        <option value='' >Seleccione una</option>
                                        {flores.map((flor, index) => (
                                            <option key={index + flor} value={flor}>{flor.toUpperCase()}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className='form-group'>
                                    <label className='text-bold'>Variedad</label>
                                    <select className='form-control' name='variedad' value={selecciones.variedad} onChange={changeBloque}>
                                        <option value='' >Seleccione una</option>
                                        {variedades.map((variedad, index) => (
                                            <option key={index + variedad} value={variedad}>{variedad.toUpperCase()}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className='form-group'>
                                    <label className='text-bold'>Color</label>
                                    <select className='form-control' name='color' value={selecciones.color} onChange={changeBloque}>
                                        <option value='' >Seleccione una</option>
                                        {colores.map((color, index) => (
                                            <option key={index + color} value={color}>{color.toUpperCase()}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {
                                gruposInputs.map((grupo, index) => <React.Fragment key={index + grupo.name}>
                                    <div className='col-lg-12 text-start h4 fw-300 pb-0 mb-1 mt-3'>{grupo.name}</div>
                                    <div className='grid-inputs col-lg-12 m-0'>
                                        {grupo.inputs.map((input, indexj) => (
                                            <div key={indexj + input.name} className='form-group'>
                                                <label className='text-bold'>{input.title}</label>
                                                <input type={input.tipo} className='form-control' name={input.name} value={selecciones[input.name]} onChange={grupo.funcion} disabled={!input.editable} />
                                            </div>
                                        ))}
                                    </div>
                                </React.Fragment>)
                            }
                        </div>
                    </div>
                </div>
            </div>

            {loader && ldr}
            <VainillaDialog data={dialog} />
        </>

    )
}

export default FormularioRegistroBloque;